module.exports = __webpack_public_path__ + "img/calendario_smartform.ef7b3801.png";